// extracted by mini-css-extract-plugin
export default {"list":"AppliedRules_list__E9cr1","emptyBox":"AppliedRules_emptyBox__Vn+Ho","rule":"AppliedRules_rule__Gq9+f","mutedText":"AppliedRules_mutedText__F+WIf"};